import { render, staticRenderFns } from "./sijitangfeibaobiao.vue?vue&type=template&id=a7ae7b24&scoped=true&"
import script from "./sijitangfeibaobiao.vue?vue&type=script&lang=js&"
export * from "./sijitangfeibaobiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ae7b24",
  null
  
)

export default component.exports